<template>
  <section class="content">
    <div class="inner">
      <div class="heading">
        <h1>Checkout</h1>
      </div>

      <div class="col col-2 padded">
        <h2>Billing Details</h2>

        <div class="row">
          <label>
            First name
            <span class="req">*</span>
          </label>
          <input maxlength="20" class="txt" type="txt" v-model="form.billing.first_name" />
        </div>
        <div class="row">
          <label>
            Surname
            <span class="req">*</span>
          </label>
          <input maxlength="20" class="txt" type="txt" v-model="form.billing.surname" />
        </div>

        <div class="row">
          <label> </label>
          <input ref="autocomplete" placeholder="Search for your location..." class="txt search-location"
            onfocus="value = ''" autocomplete="new-password" type="text" />
        </div>

        <div class="row">
          <label>
            Address
            <span class="req">*</span>
          </label>
          <input maxlength="100" class="txt" type="txt" v-model="form.billing.address_1" />
        </div>
        <div class="row">
          <label></label>
          <input maxlength="100" class="txt" type="txt" v-model="form.billing.address_2" />
        </div>
        <div class="row">
          <label>
            Town / City
            <span class="req">*</span>
          </label>
          <input maxlength="40" class="txt" type="txt" v-model="form.billing.town_city" />
        </div>
        <div class="row">
          <label>
            County
            <span class="req">*</span>
          </label>
          <input class="txt" type="txt" v-model="form.billing.county" />
        </div>
        <div class="row">
          <label>
            Postcode
            <span class="req">*</span>
          </label>
          <input class="txt" type="txt" v-model="form.billing.post_code" />
        </div>

        <h2>Contact Details</h2>
        <div class="row">
          <label>Telephone</label>
          <input class="txt" type="tel" v-model="form.contact.telephone" />
        </div>
        <div class="row">
          <label>
            Mobile
            <span class="req">*</span>
          </label>
          <input class="txt" type="tel" v-model="form.contact.mobile" />
        </div>
        <div class="row">
          <label>
            Email
            <span class="req">*</span>
          </label>
          <input class="txt" type="email" v-model="form.contact.email" />
        </div>
      </div>

      <!-- If not collection-->
      <div v-if="basket.delivery_type == 'Delivery'" class="col col-2 padded">
        <h2>Delivery Details</h2>

        <p class="same">
          <a @click.prevent="copyFromBilling" href> <i class="fa fa-copy"></i> Copy from billing details </a>
        </p>

        <div class="row">
          <label>
            First name
            <span class="req">*</span>
          </label>
          <input maxlength="20" class="txt" type="txt" v-model="form.delivery.first_name" />
        </div>
        <div class="row">
          <label>
            Surname
            <span class="req">*</span>
          </label>
          <input maxlength="20" class="txt" type="txt" v-model="form.delivery.surname" />
        </div>

        <div class="row">
          <label> </label>
          <input ref="autocompletedel" placeholder="Search for your location..." class="txt search-location"
            onfocus="value = ''" autocomplete="new-password" type="text" />
        </div>

        <div class="row">
          <label>
            Address
            <span class="req">*</span>
          </label>
          <input maxlength="100" class="txt" type="txt" v-model="form.delivery.address_1" />
        </div>
        <div class="row">
          <label></label>
          <input maxlength="100" class="txt" type="txt" v-model="form.delivery.address_2" />
        </div>
        <div class="row">
          <label>
            Town / City
            <span class="req">*</span>
          </label>
          <input maxlength="40" class="txt" type="txt" v-model="form.delivery.town_city" />
        </div>
        <div class="row">
          <label>
            County
            <span class="req">*</span>
          </label>
          <input class="txt" type="txt" v-model="form.delivery.county" />
        </div>
        <div class="row">
          <label>
            Postcode
            <span class="req">*</span>
          </label>
          <input class="txt" type="txt" v-model="form.delivery.post_code" />
        </div>
        <div class="row">
          <label>Other Instructions</label>
          <textarea class="txt" v-model="form.delivery.other"></textarea>
        </div>
        <div class="row">
          <label>Delivery Instructions</label>
          <textarea class="txt" v-model="form.delivery.instructions"></textarea>
        </div>
      </div>

      <div v-if="basket.delivery_type == 'Collection'" class="col col-2 padded">
        <h2>Collection Address</h2>
        <p>Unit 1<br />Thickley Close<br />Mansfield<br />NG20 8UR</p>
      </div>

      <div class="actions">
        <p class="terms">
          <input id="chkterms" type="checkbox" v-model="form.terms_agreed" />
          <label for="chkterms">
            I have read and accepted the
            <a href="/terms-conditions" rel="nofollow" target="_blank">terms &amp; conditions</a>
          </label>
        </p>

        <span class="success" v-show="success">Thanks, your request has been sent!</span>
        <span class="error" v-show="error">{{ errormessage }}</span>

        <a @click.prevent="checkout" class="config-buy" v-if="grandTotal">
          <img alt="Proceed" src="../assets/ripple.svg" /> Proceed to payment
        </a>
      </div>
    </div>

    <form action="https://live.opayo.eu.elavon.com/gateway/service/vspform-register.vsp" id="paymentform" method="post">
      <input id="VPSProtocol" name="VPSProtocol" type="hidden" />
      <input id="TxType" name="TxType" type="hidden" />
      <input id="Vendor" name="Vendor" type="hidden" />
      <input id="Crypt" name="Crypt" type="hidden" />
    </form>
  </section>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

import api from "@/services/api"

export default {
  name: "PageCheckout",
  data: function () {
    return {
      search: "",

      success: false,
      error: false,
      errormessage: "",
      form: {},
      initial_values: {
        billing: {},
        contact: {},
        delivery: {}
      },

      autocomplete: null,
      autocompletedel: null
    }
  },
  computed: {
    ...mapState(["basket"]),
    ...mapGetters({ subTotal: "basket/subTotal", grandTotal: "basket/grandTotal" })
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {
      componentRestrictions: { country: "gb" },
      types: ["geocode"]
    })
    this.autocompletedel = new google.maps.places.Autocomplete(this.$refs.autocompletedel, {
      componentRestrictions: { country: "gb" },
      types: ["geocode"]
    })

    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace()
      this.$refs.autocomplete.value = ""

      var street_number = place.address_components.filter(ac => ac.types.filter(t => t == "street_number").length)
      if (street_number.length) street_number = street_number[0].long_name
      else street_number = ""
      var street = place.address_components.filter(ac => ac.types.filter(t => t == "route").length)
      if (street.length) street = street[0].long_name
      else street = ""
      var locality = place.address_components.filter(ac => ac.types.filter(t => t == "locality").length)
      if (locality.length) locality = locality[0].long_name
      else locality = ""
      var town = place.address_components.filter(ac => ac.types.filter(t => t == "postal_town").length)
      if (town.length) town = town[0].long_name
      else town = ""
      var county = place.address_components.filter(
        ac => ac.types.filter(t => t == "administrative_area_level_2").length
      )
      if (county.length) county = county[0].long_name
      else county = ""
      var postcode = place.address_components.filter(ac => ac.types.filter(t => t == "postal_code").length)
      if (postcode.length) postcode = postcode[0].long_name
      else postcode = ""

      this.$set(this.form.billing, "address_1", [street_number, street].join(" "))
      this.$set(this.form.billing, "address_2", locality)
      this.$set(this.form.billing, "town_city", town)
      this.$set(this.form.billing, "county", county)
      this.$set(this.form.billing, "post_code", postcode)
    })

    this.autocompletedel.addListener("place_changed", () => {
      let place = this.autocompletedel.getPlace()
      this.$refs.autocompletedel.value = ""

      var street_number = place.address_components.filter(ac => ac.types.filter(t => t == "street_number").length)
      if (street_number.length) street_number = street_number[0].long_name
      else street_number = ""
      var street = place.address_components.filter(ac => ac.types.filter(t => t == "route").length)
      if (street.length) street = street[0].long_name
      else street = ""
      var locality = place.address_components.filter(ac => ac.types.filter(t => t == "locality").length)
      if (locality.length) locality = locality[0].long_name
      else locality = ""
      var town = place.address_components.filter(ac => ac.types.filter(t => t == "postal_town").length)
      if (town.length) town = town[0].long_name
      else town = ""
      var county = place.address_components.filter(
        ac => ac.types.filter(t => t == "administrative_area_level_2").length
      )
      if (county.length) county = county[0].long_name
      else county = ""
      var postcode = place.address_components.filter(ac => ac.types.filter(t => t == "postal_code").length)
      if (postcode.length) postcode = postcode[0].long_name
      else postcode = ""

      this.$set(this.form.delivery, "address_1", [street_number, street].join(" "))
      this.$set(this.form.delivery, "address_2", locality)
      this.$set(this.form.delivery, "town_city", town)
      this.$set(this.form.delivery, "county", county)
      this.$set(this.form.delivery, "post_code", postcode)
    })
  },
  created: function () {
    this.form = JSON.parse(JSON.stringify(this.initial_values))
  },
  methods: {
    checkout: function () {
      this.success = false
      this.error = false

      if (
        !this.form.billing.first_name ||
        !this.form.billing.surname ||
        !this.form.billing.address_1 ||
        !this.form.billing.town_city ||
        !this.form.billing.county ||
        !this.form.billing.post_code ||
        !this.form.contact.email ||
        !this.form.contact.mobile
      ) {
        this.errormessage = "Please fill in all required fields, thanks!"
        this.error = true
        return false
      }

      if (this.basket.delivery_type == "Delivery") {
        if (
          !this.form.delivery.first_name ||
          !this.form.delivery.surname ||
          !this.form.delivery.address_1 ||
          !this.form.delivery.town_city ||
          !this.form.delivery.county ||
          !this.form.delivery.post_code
        ) {
          this.errormessage = "Please fill in all required fields, thanks!"
          this.error = true
          return false
        }
      }

      if (!this.form.terms_agreed) {
        this.errormessage = "Please agree to the terms & conditions, thanks!"
        this.error = true
        return false
      }

      var form = this.form
      var basket = JSON.parse(JSON.stringify(this.basket))
      basket.sub_total = this.subTotal
      basket.grand_total = this.grandTotal

      api
        .generateSagePayFields({ form, basket })
        .then(res => {
          document.getElementById("VPSProtocol").value = res.data.VPSProtocol
          document.getElementById("TxType").value = res.data.TxType
          document.getElementById("Vendor").value = res.data.Vendor
          document.getElementById("Crypt").value = res.data.Crypt

          var theForm = document.getElementById("paymentform")
          theForm.submit()
        })
        .catch(() => {
          this.errormessage = "There has been an error submiting your message"
          this.error = true
        })
    },
    copyFromBilling: function () {
      var instructions = this.form.delivery.instructions
      var other = this.form.delivery.other
      this.form.delivery = JSON.parse(JSON.stringify(this.form.billing))
      this.form.delivery.instructions = instructions
      this.form.delivery.other = other
    }
  }
}
</script>

<style scoped>
h2 {
  margin-top: 2rem;
}

.row {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  width: 100%;
  display: table;
}

textarea {
  height: 8rem;
}

.txt {
  border: 1px solid #d5d5d5;
  width: 30rem;
  padding: 1rem;
  float: left;
}

.search-location {
  background: #f6f6f6;
}

.row label {
  display: block;
  float: left;
  width: 20rem;
  padding-top: 0.5rem;
}

.same {
  padding-top: 0;
  margin-top: 0;
}

.terms a,
.same a,
.req {
  color: #f79227;
}

.terms input {
  margin-right: 0.5rem;
}

.heading,
.actions {
  clear: both;
  padding: 3rem 2%;
}

.heading {
  padding-bottom: 1.5rem;
}

i {
  color: #ccc;
  margin-right: 0.5rem;
}

.error {
  color: #cc0000;
  display: block;
  padding: 1rem 0;
}

@media screen and (max-width: 950px) {
  .row label {
    width: 30%;
    padding-right: 5%;
  }

  .row .txt {
    width: 65%;
  }
}

@media screen and (max-width: 600px) {
  .config-buy {
    width: 100%;
  }
}
</style>
